import React from 'react';
import { Box, AppBar, Toolbar, Tabs, Tab } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { useTheme } from '../context/ThemeContext';

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const muiTheme = useMuiTheme();
  const { themeColors } = useTheme();
  
  const getCurrentTab = () => {
    if (location.pathname.includes('/contracts')) return 1;
    if (location.pathname.includes('/configuration')) return 2;
    return 0;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" sx={{ backgroundColor: themeColors.primary }}>
        <Toolbar>
          <Tabs 
            value={getCurrentTab()} 
            onChange={(e, newValue) => {
              switch(newValue) {
                case 0:
                  navigate('/');
                  break;
                case 1:
                  navigate('/contracts');
                  break;
                case 2:
                  navigate('/configuration');
                  break;
                default:
                  navigate('/');
              }
            }}
            sx={{ 
              width: '100%',
              '& .MuiTabs-indicator': {
                backgroundColor: themeColors.secondary
              },
              '& .Mui-selected': {
                color: `${themeColors.secondary} !important`
              }
            }}
            centered
            textColor="inherit"
          >
            <Tab 
              icon={<DashboardIcon />} 
              label="DASHBOARD" 
              sx={{ color: 'white' }}
            />
            <Tab 
              icon={<DescriptionIcon />} 
              label="GESTIÓN DE CONTRATO" 
              sx={{ color: 'white' }}
            />
            <Tab 
              icon={<SettingsIcon />} 
              label="CONFIGURACIÓN" 
              sx={{ color: 'white' }}
            />
          </Tabs>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {children}
      </Box>
    </Box>
  );
}

export default Layout; 